import { useQuery } from '@eigtech/ui-shared-api'
import { useAuth0 } from '@eigtech/ui-shared-auth'
import { getContactQueryOptions } from './getContacts'

export function useGetUserContact() {
  const { user } = useAuth0()

  return useQuery(getContactQueryOptions(user?.sub ?? ''))
}
